<template>
  <div class="basic">
    <div class="basic-header">
      <h2>- 企业基本信息/Basic Information -</h2>
    </div>

    <h3>
      <Form
        ref="formInline"
        :model="formInline"
        style="width: 100%"
        :rules="ruleInline"
        label-position="top"
        @on-validate="getvalidate"
      >
        <div style="border: solid 1px #e5e5e5; margin-bottom: 30px; padding-top: 20px">
          <!-- 公司名称 -->
          <div class="basic-name">
            <Row :gutter="10">
              <Col span="12">
                <div style="display: flex">
                  <FormItem label="公司名称（中文）/Company Name" prop="companyName">
                    <Input
                      type="text"
                      v-model="formInline.companyName"
                      style="width: 270px; margin-right: 10px"
                      placeholder="请输入企业名称（必须和营业执照一致）"
                      @on-blur="onBlurChang"
                    />
                  </FormItem>
                  <FormItem label="简称/Company Name For Short" prop="companyNameShort">
                    <Input
                      type="text"
                      placeholder="请输入简称/Please enter Company Name For Short"
                      v-model="formInline.companyNameShort"
                      style="width: 270px; margin-right: 10px"
                    />
                  </FormItem>
                </div>
              </Col>
              <Col span="12">
                <div style="display: flex">
                  <FormItem label="英文名称/Company Name" prop="">
                    <Input
                      type="text"
                      placeholder="请输入英文名称/Please enter Company Name"
                      v-model="formInline.companyNameEn"
                      style="width: 270px; margin-right: 10px"
                    />
                  </FormItem>
                  <FormItem
                    label="统一社会信用代码"
                    prop="creditCode"
                    id="creditCode"
                    v-if="isShowFormEl"
                  >
                    <Input
                      type="text"
                      v-model="formInline.creditCode"
                      style="width: 270px"
                      placeholder="请输入统一社会信用代码"
                      @on-blur="onBlurChang"
                    />
                  </FormItem>
                </div>
              </Col>
            </Row>
          </div>

          <!-- 公司地址 -->
          <div class="basic-name">
            <Row :gutter="10">
              <Col span="12">
                <FormItem label="公司地址/Address" required prop="addresss">
                  <div style="width: 550px">
                    <mFormAddress
                      v-model="formInline.addresss"
                      @change="validAddresss"
                    ></mFormAddress>
                  </div>
                </FormItem>
              </Col>

              <Col span="12">
                <div style="padding: 0 0 3px 0"></div>
                <div style="display: flex">
                  <FormItem prop="address" id="address" label="详细地址/Address">
                    <Input
                      type="text"
                      placeholder="请输入详细地址/Please enter address"
                      v-model="formInline.address"
                      style="width: 410px; margin-right: 10px"
                    />
                  </FormItem>
                  <FormItem prop="postcode" id="postcode" label="邮编/Zip/Postal Code">
                    <Input
                      type="text"
                      placeholder="请输入邮编/Please enter Zip/Postal Code"
                      v-model="formInline.postcode"
                      style="width: 130px"
                    />
                  </FormItem>
                </div>
              </Col>
            </Row>
          </div>

          <div class="basic-address">
            <Row :gutter="10">
              <Col span="12">
                <FormItem prop="productName" label="主推产品名称/Brand Name">
                  <Input
                    type="text"
                    placeholder="请输入主推产品名称/Please enter Brand Name"
                    v-model="formInline.productName"
                    style="width: 552px"
                    maxlength="50"
                  />
                </FormItem>
              </Col>
              <Col span="12" v-if="isShowFormEl">
                <FormItem
                  label="营业执照上传（小于5M）/Company registration certificate"
                  required
                >
                  <div style="display: flex; position: relative">
                    <Upload
                      ref="upload"
                      :show-upload-list="false"
                      :default-file-list="defaultList"
                      :on-success="handleSuccess"
                      :format="['jpg', 'png','pdf']"
                      :max-size="5120"
                      :headers="formHeaders"
                      :on-format-error="handleFormatError"
                      :on-exceeded-size="handleMaxSize"
                      :before-upload="handleBeforeUpload"
                      :action="uploadUrl"
                      style="margin-right: 10px"
                    >
                      <div class="upload-btn">
                        上传营业执照/Company registration certificate
                      </div>
                    </Upload>
                    <p
                      style="
                        position: absolute;
                        left: 0;
                        top: 34px;
                        font-size: 12px;
                        color: #808080;
                      "
                    >
                      仅支持jpg,png,pdf,不超过5M/jpg,png,pdf,only, within 5M
                    </p>
                    <div class="license-img">
                      <template v-if="uploadList && uploadList.length">
                        <div
                          class="license-img-list"
                          v-for="(item, index) in uploadList"
                          :key="'upload' + index"
                        >
                          <template v-if="item.status === 'finished'">
                            <span class="txt1" :title="item.name" v-if="item.name">{{
                              item.name.split(".")[0]
                            }}</span>
                            <span class="line"></span>
                            <span @click="handleRemoveByArr(item)">删除</span>
                          </template>
                        </div>
                      </template>
                    </div>
                  </div>
                </FormItem>
              </Col>
            </Row>
          </div>
        </div>

        <!-- 展会联系人 -->
        <div class="basic-link">
          <FormItem label="展会联系人/Contact Person" required> </FormItem>
        </div>
        <div style="border: solid 1px #e5e5e5; margin-bottom: 30px">
          <div class="basic-links">
            <Row :gutter="10">
              <Col span="12">
                <div style="display: flex">
                  <FormItem label="姓名/Name" prop="linkMan">
                    <Input
                      type="text"
                      placeholder="展会联系人姓名/Contact Person Name"
                      v-model="formInline.linkMan"
                      style="width: 270px; margin-right: 10px"
                    />
                  </FormItem>
                  <FormItem label="职务/Job Title" prop="linkTitle">
                    <Input
                      type="text"
                      placeholder="展会联系人职务/Contact Person Job Title"
                      v-model="formInline.linkTitle"
                      style="width: 270px"
                    />
                  </FormItem>
                </div>
              </Col>
              <Col span="12">
                <div style="display: flex">
                  <FormItem label="手机/Contact Number" prop="linkMob">
                    <Input
                      type="text"
                      placeholder="展会联系人手机号/Contact Person Contact Number"
                      v-model="formInline.linkMob"
                      style="width: 270px; margin-right: 10px"
                    />
                  </FormItem>
                  <FormItem label="邮箱/E-mail" prop="linkEmail">
                    <Input
                      type="text"
                      placeholder="展会联系人邮箱/Contact Person E-mail"
                      v-model="formInline.linkEmail"
                      style="width: 270px"
                    />
                  </FormItem>
                </div>
              </Col>
            </Row>
            <Row :gutter="10">
              <Col span="12">
                <Row>
                  <Col span="12">
                    <FormItem label="座机电话/Tel" :required="false">
                      <div style="display: flex">
                        <FormItem prop="linkCode">
                          <Input
                            type="number"
                            v-model="formInline.linkCode"
                            style="width: 90px; margin-right: 10px"
                            placeholder="区号"
                          />
                        </FormItem>
                        一 &nbsp
                        <FormItem prop="linkTelephone">
                          <Input
                            type="number"
                            v-model="formInline.linkTelephone"
                            style="width: 140px; margin-right: 10px"
                            placeholder="电话号码"
                          />
                        </FormItem>
                      </div>
                      <p
                        style="
                          line-height: 1;
                          font-size: 12px;
                          color: #808080;
                          position: relative;
                          top: -12px;
                        "
                      >
                        示例/Examples：010-6343 0880
                      </p>
                    </FormItem>
                  </Col>
                  <Col span="12">
                    <FormItem
                      label="QQ"
                      prop=""
                      style="position: relative; margin-left: -10px"
                    >
                      <Input
                        type="number"
                        placeholder="展会联系人QQ/Contact Person QQ"
                        v-model="formInline.linkQQ"
                        style="width: 270px"
                      />
                    </FormItem>
                  </Col>
                </Row>
              </Col>
              <Col span="12">
                <FormItem label="微信/Wechat" prop="">
                  <Input
                    type="text"
                    placeholder="展会联系人微信/Contact Person Wechat"
                    v-model="formInline.linkWeChat"
                    style="width: 270px"
                  />
                </FormItem>
              </Col>
            </Row>
          </div>
        </div>

        <!-- 开票信息 -->
        <div class="basic-invoiceType">
          <p style="padding-left: 11px; font-size: 18px">开票信息/Invoice</p>
          <Checkbox v-model="isInvoice"><span>无开票信息/No Invoice</span></Checkbox>
        </div>
        <div style="border: solid 1px #e5e5e5; margin-bottom: 30px">
          <div class="basic-invoices" v-if="!isInvoice">
            <Row :gutter="10">
              <Col span="12">
                <div style="display: flex">
                  <FormItem label="发票抬头" prop="invoiceTitle">
                    <Input
                      type="text"
                      placeholder="请输入发票抬头"
                      v-model="formInline.invoiceTitle"
                      style="width: 270px; margin-right: 10px"
                    />
                  </FormItem>
                  <FormItem label="税号" prop="invoiceCode">
                    <Input
                      type="text"
                      placeholder="请输入税号"
                      v-model="formInline.invoiceCode"
                      style="width: 270px"
                    />
                  </FormItem>
                </div>
              </Col>
              <Col span="12">
                <div style="display: flex">
                  <FormItem label="单位地址" prop="invoiceAddress">
                    <Input
                      type="text"
                      placeholder="请输入单位地址"
                      v-model="formInline.invoiceAddress"
                      style="width: 270px; margin-right: 10px"
                    />
                  </FormItem>
                  <FormItem label="电话号码" prop="invoiceTelephone">
                    <Input
                      type="number"
                      placeholder="请输入电话号码"
                      v-model="formInline.invoiceTelephone"
                      style="width: 270px"
                    />
                  </FormItem>
                </div>
              </Col>
            </Row>
            <Row :gutter="10">
              <Col span="12">
                <div style="display: flex">
                  <FormItem label="开户银行" prop="invoiceBank">
                    <Input
                      type="text"
                      v-model="formInline.invoiceBank"
                      placeholder="请输入开户银行"
                      style="width: 270px; margin-right: 10px"
                    />
                  </FormItem>
                  <FormItem label="银行账户" prop="invoiceBankAccount">
                    <Input
                      type="text"
                      v-model="formInline.invoiceBankAccount"
                      placeholder="请输入银行账户"
                      style="width: 270px"
                    />
                  </FormItem>
                </div>
              </Col>
              <Col span="12">
                <div style="display: flex">
                  <FormItem label="发票类型" prop="invoiceType">
                    <RadioGroup v-model="formInline.invoiceType">
                      <Radio label="增值税专票">
                        <span>增值税专用发票</span>
                      </Radio>
                      <Radio label="增值税普票">
                        <span>增值税普通发票</span>
                      </Radio>
                    </RadioGroup>
                  </FormItem>
                </div>
              </Col>
            </Row>
            <Row :gutter="10">
              <Col span="12">
                <FormItem label="发票邮寄地址" required prop="invoiceMalingAdresss">
                  <div style="width: 550px">
                    <mFormAddress
                      v-model="formInline.invoiceMalingAdresss"
                      @change="MalingAdresssAddresss"
                    ></mFormAddress>
                  </div>
                </FormItem>
              </Col>

              <Col span="10">
                <div style="padding: 0 0 3px 0"></div>
                <div style="display: flex">
                  <FormItem prop="invoiceMalingAdress" label="详细地址">
                    <Input
                      type="text"
                      placeholder="请输入详细地址"
                      v-model="formInline.invoiceMalingAdress"
                      style="width: 410px; margin-right: 10px"
                    />
                  </FormItem>
                  <FormItem prop="invoiceMalingCode" label="邮编">
                    <Input
                      type="text"
                      placeholder="请输入邮编"
                      v-model="formInline.invoiceMalingCode"
                      style="width: 130px"
                    />
                  </FormItem>
                </div>
              </Col>
            </Row>
            <Row :gutter="10">
              <Col span="12">
                <div style="display: flex">
                  <FormItem label="发票收件人" prop="invoiceRecivePerson">
                    <Input
                      type="text"
                      placeholder="请输入发票收件人"
                      v-model="formInline.invoiceRecivePerson"
                      style="width: 270px; margin-right: 10px"
                    />
                  </FormItem>
                  <FormItem label="收件人电话" prop="invoiceReciveTel">
                    <Input
                      type="number"
                      placeholder="请输入收件人电话"
                      v-model="formInline.invoiceReciveTel"
                      style="width: 270px"
                    />
                  </FormItem>
                </div>
              </Col>
            </Row>
          </div>
        </div>
        <!-- <div class="handle-box">
        <Button :loading="loading" @click="handleSubmit('formInline')" class="handle-box-btn" type="primary">保存并提交</Button>
      </div> -->
      </Form>
    </h3>
  </div>
</template>

<script>
import mFormAddress from "@/components/m-form/m-form-address.vue";
import { mapGetters, mapActions } from "vuex";
import { validator } from "@/other/validator";
export default {
  name: "register-form", // 参展申请 - 基本信息
  components: {
    mFormAddress,
  },
  data() {
    const that = this;
    // const zhValid = (rule, value, callback) => {
    //   if (/^[\u4e00-\u9fa5]+$/.test(value)) {
    //     callback();
    //   } else {
    //     callback(new Error("公司名称格式有误"));
    //   }
    // };
    // 判断英文
    const enValid = (rule, value, callback) => {
      if (!value) {
        callback();
      } else {
        if (/^([a-zA-Z]+\s)*[a-zA-Z]+$/.test(value)) {
          callback();
        } else {
          callback(new Error("英文名称格式有误"));
        }
      }
    };
    const companyAddressValid = (rule, value, callback) => {
      if (
        that.formInline.addresss.country &&
        that.formInline.addresss.country === "中国"
      ) {
        // 中国 判断省份和城市是否选择
        if (!that.formInline.addresss.province) {
          callback(new Error("省份为空/Please enter Province"));
        } else if (!that.formInline.addresss.city) {
          callback(new Error("城市为空/Please enter City"));
        } else {
          callback();
        }
      } else {
        if (that.formInline.addresss.country) {
          callback();
        } else {
          callback(new Error("地址为空/Please enter Address"));
        }
      }
    };
    const invoiceAddressValid = (rule, value, callback) => {
      if (that.isInvoice) {
        // 没有发票信息
        callback();
      } else {
        if (
          that.formInline.invoiceMalingAdresss.country &&
          that.formInline.invoiceMalingAdresss.country === "中国"
        ) {
          // 中国 判断省份和城市是否选择
          if (!that.formInline.invoiceMalingAdresss.province) {
            callback(new Error("省份为空"));
          } else if (!that.formInline.invoiceMalingAdresss.city) {
            callback(new Error("城市为空"));
          } else {
            callback();
          }
        } else {
          if (that.formInline.invoiceMalingAdresss.country) {
            callback();
          } else {
            callback(new Error("地址为空"));
          }
        }
      }
    };
    const invoiceTitleValid = (rule, value, callback) => {
      if (that.isInvoice) {
        // 没有发票信息
        callback();
      } else {
        if (!value) {
          callback(new Error("请输入发票抬头"));
        } else {
          callback();
        }
      }
    };
    const invoiceCodeValid = (rule, value, callback) => {
      if (that.isInvoice) {
        // 没有发票信息
        callback();
      } else {
        if (value) {
          if (/^[A-Z0-9]{15}$|^[A-Z0-9]{17}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/.test(value)) {
            callback();
          } else {
            callback("发票税号格式有误");
          }
        } else {
          callback(new Error("请输入发票税号"));
        }
      }
    };
    const invoiceAddValid = (rule, value, callback) => {
      if (that.isInvoice) {
        // 没有发票信息
        callback();
      } else {
        if (!value) {
          callback(new Error("请输入单位地址"));
        } else {
          callback();
        }
      }
    };
    const invoiceTelephoneValid = (rule, value, callback) => {
      if (that.isInvoice) {
        // 没有发票信息
        callback();
      } else {
        if (!value) {
          callback(new Error("请输入单位电话号码"));
        } else {
          callback();
        }
      }
    };
    const invoiceBankValid = (rule, value, callback) => {
      if (that.isInvoice) {
        // 没有发票信息
        callback();
      } else {
        if (!value) {
          callback(new Error("请输入开户银行"));
        } else {
          callback();
        }
      }
    };
    const invoiceBankAccountValid = (rule, value, callback) => {
      if (that.isInvoice) {
        // 没有发票信息
        callback();
      } else {
        if (that.formInline.invoiceType === "增值税专票") {
          if (!value) {
            callback(new Error("请输入银行账号"));
          } else {
            if (/^[0-9]{0,50}$/.test(value)) {
              callback();
            } else {
              callback(new Error("银行账号格式有误"));
            }
          }
        } else {
          if (!value) {
            callback();
          } else {
            if (/^[0-9]{0,50}$/.test(value)) {
              callback();
            } else {
              callback(new Error("银行账号格式有误"));
            }
          }
        }
      }
    };
    const invoiceTypeValid = (rule, value, callback) => {
      if (that.isInvoice) {
        // 没有发票信息
        callback();
      } else {
        if (!value) {
          callback(new Error("请输入发票类型"));
        } else {
          callback();
        }
      }
    };
    const invoiceMalingAdressValid = (rule, value, callback) => {
      if (that.isInvoice) {
        // 没有发票信息
        callback();
      } else {
        if (!value) {
          callback(new Error("请输入详细地址"));
        } else {
          callback();
        }
      }
    };
    const invoiceRecivePersonValid = (rule, value, callback) => {
      if (that.isInvoice) {
        // 没有发票信息
        callback();
      } else {
        if (!value) {
          callback(new Error("请输入发票收件人"));
        } else {
          callback();
        }
      }
    };
    const invoiceReciveTelValid = (rule, value, callback) => {
      if (that.isInvoice) {
        // 没有发票信息
        callback();
      } else {
        if (!value) {
          callback(new Error("请输入收件人电话"));
        } else {
          callback();
        }
      }
    };
    const linkMobValid = (rule, value, callback) => {
      if (!that.isZh) {
        if (!value) {
          callback(new Error("请输入手机号码"));
        } else {
          callback();
        }
      } else {
        if (/^[1][0-9]{10}$/.test(value)) {
          callback();
        } else {
          callback("请输入正确的手机号码");
        }
      }
    };
    return {
      loading: false,
      isInvoice: false,
      formInline: {
        // 企业基本信息/Basic Information
        companyName: "", // 公司名称
        companyNameShort: "", // 公司简称
        companyNameEn: "", // 公司英文名称
        creditCode: "", // 统一社会信用代码
        address: "", // 详细地址
        addresss: {
          country: "中国", // 国家
          province: "", // 省份
          city: "", // 城市
          county: "", // 区县
        },
        postcode: "",
        productName: "", // 母公司名称

        // 展会联系人
        linkMan: "",
        linkTitle: "",
        linkTelephone: "",
        linkEmail: "",
        linkCode: "", // 区号
        linkMob: "", // 电话号码
        linkQQ: "",
        linkWeChat: "",

        // 开票信息
        invoiceTitle: "",
        invoiceCode: "",
        invoiceAddress: "",
        invoiceTelephone: "",
        invoiceBank: "",
        invoiceBankAccount: "",
        invoiceType: "增值税专票",
        invoiceMalingAdresss: {
          country: "中国", // 国家
          province: "", // 省份
          city: "", // 城市
          county: "", // 区县
        },
        invoiceMalingAdress: "",
        invoiceMalingCode: "",
        invoiceRecivePerson: "",
        invoiceReciveTel: "",
      },
      formInline1: {
        // 企业基本信息/Basic Information
        companyName: "上海连战技术有限公司", // 公司名称
        companyNameShort: "连战", // 公司简称
        companyNameEn: "lianzhan", // 公司英文名称
        creditCode: "91310118MA1JM12CX7", // 统一社会信用代码
        address: "金沙江西路1555路慧创国际16号2层", // 详细地址
        addresss: {
          country: "中国", // 国家
          province: "上海", // 省份
          city: "嘉定", // 城市
          county: "", // 区县
        },
        postcode: "201803",
        productName: "技术软件",

        // 展会联系人
        linkMan: "李某",
        linkTitle: "技术",
        linkMob: "13122959676",
        linkEmail: "2624006658@qq.com",
        linkCode: "021", // 区号
        linkTelephone: "8888888", // 电话号码
        linkQQ: "2624006658",
        linkWeChat: "xiansheng",

        // 开票信息
        invoiceTitle: "慕渊（上海）智能科技有限公司",
        invoiceCode: "91310118MA1JM12CX7",
        invoiceAddress: "上海上海市嘉定区江桥镇金沙江西路1555路慧创国际16号2层",
        invoiceTelephone: "13122959676",
        invoiceBank: "招商银行",
        invoiceBankAccount: "6214837922727635",
        invoiceType: "增值税专票",
        invoiceMalingAdresss: {
          country: "中国", // 国家
          province: "上海", // 省份
          city: "嘉定", // 城市
          county: "", // 区县
        },
        invoiceMalingAdress: "江桥镇金沙江西路1555路慧创国际16号2层",
        invoiceMalingCode: "201803",
        invoiceRecivePerson: "王二",
        invoiceReciveTel: "13122959677",
      },
      ruleInline: {
        // 企业基本信息/Basic Information
        companyName: [
          {
            required: true,
            message: "请输入公司名称/Please enter Company Name",
            trigger: "blur",
          },
          //   { validator: zhValid, trigger: "blur" },
        ],
        companyNameShort: [
          {
            required: true,
            message: "请输入公司简称/Please enter Company Name For Short",
            trigger: "blur",
          },
        ],
        companyNameEn: [{ validator: enValid, trigger: "blur" }],
        creditCode: [
          {
            required: true,
            message: "统一社会信用代码不能为空",
            trigger: "blur",
          },
          ...validator.CreditCode,
        ],
        addresss: [
          {
            required: true,
            validator: companyAddressValid,
            trigger: "blur",
          },
        ],
        address: [
          {
            required: true,
            message: "请输入详细地址/Please enter Address",
            trigger: "blur",
          },
        ],

        // 展会联系人
        linkMan: [
          {
            required: true,
            message: "请输入姓名/Please enter Name",
            trigger: "blur",
          },
        ],
        linkTitle: [
          {
            required: true,
            message: "请输入职务/Please enter Job Title",
            trigger: "blur",
          },
        ],
        linkQQ: [
          {
            required: true,
            message: "请输入QQ/Please enter QQ",
            trigger: "blur",
          },
        ],
        linkWeChat: [
          {
            required: true,
            message: "请输入微信/Please enter Wechat",
            trigger: "blur",
          },
        ],
        linkMob: [
          {
            required: true,
            validator: linkMobValid,
            // message: "请输入手机号/Please enter",
            trigger: "blur",
          },

          //   ...validator.phone,
        ],
        linkEmail: validator.email,

        // 开票信息
        invoiceTitle: [{ required: true, validator: invoiceTitleValid, trigger: "blur" }],
        invoiceCode: [{ required: true, validator: invoiceCodeValid, trigger: "blur" }],
        invoiceAddress: [{ required: true, validator: invoiceAddValid, trigger: "blur" }],
        invoiceTelephone: [
          { required: true, validator: invoiceTelephoneValid, trigger: "blur" },
        ],
        invoiceBank: [{ required: true, validator: invoiceBankValid, trigger: "blur" }],
        invoiceBankAccount: [
          {
            required: true,
            validator: invoiceBankAccountValid,
            trigger: "blur",
          },
        ],
        invoiceType: [{ required: true, validator: invoiceTypeValid, trigger: "blur" }],
        invoiceMalingAdresss: [
          {
            required: true,
            validator: invoiceAddressValid,
            trigger: "blur",
          },
        ],
        invoiceMalingAdress: [
          {
            required: true,
            validator: invoiceMalingAdressValid,
            trigger: "blur",
          },
        ],
        invoiceRecivePerson: [
          {
            required: true,
            validator: invoiceRecivePersonValid,
            trigger: "blur",
          },
        ],
        invoiceReciveTel: [
          { required: true, validator: invoiceReciveTelValid, trigger: "blur" },
        ],
      },
      defaultList: [],
      uploadList: [],
      uploadName: "",

      isExport: true, // 是否是外销企业
      isListed: true, // 是否是上市公司
      isTop500: true, // 是否是世界五百强
      isMicroEnterprise: true, // 是否为小微企业
      isHighTech: true, // 是否为高新技术企业

      basicInfo: null,
      validateList: [],
      ElepropName: "", //验证错误的prop名
      companyId: "", //公司ID
      isOption: true, //企业经营类型是否是选择框

      countryList: [],
      provinceArr: [],
      citiesArr: [],
      isShowFormEl: true,
      isMes: false,
    };
  },

  watch: {
    "formInline.addresss.country": function (newValue, ) {
      //console.log(newValue);
      if (newValue == "中国") {
        this.isShowFormEl = true;
        this.$store.commit("updateValue", this.isShowFormEl);
      } else {
        this.isShowFormEl = false;
        this.$store.commit("updateValue", this.isShowFormEl);
      }
    },
    "formInline.addresss.province": function (newValue, ) {
      //console.log(newValue);
      if (
        newValue == "香港" ||
        newValue == "澳门" ||
        newValue == "台湾" ||
        newValue == ""
      ) {
        this.isShowFormEl = false;
        this.$store.commit("updateValue", this.isShowFormEl);
      } else {
        this.isShowFormEl = true;
        this.$store.commit("updateValue", this.isShowFormEl);
      }
    },
    isZh() {
      //console.log("isZh:", newValue);
    },
  },
  computed: {
    isZh() {
      //console.log(this.$store.state.isZh, "this.$store.state.isZh;");
      return this.$store.state.isZh;
    },
    ...mapGetters({
      formHeaders: "getFormHeaders",
      uploadUrl: "getUploadUrl",
      exhibitionId: "getExhibitionId",
      company: "getCompany",
    }),
  },
  mounted() {
    this.$store.commit("updateValue", true);
  },
  methods: {
    ...mapActions({
      getCityByParentId: "exhibitionModule/getCityByParentId",
      getPCOrNHNEExist: "exhibitionModule/getPCOrNHNEExist",

      addApplyCompany: "addApplyCompany",
      editApplyCompany: "editApplyCompany",
    }),

    async onBlurChang() {
    //   if (this.formInline.companyName && this.formInline.creditCode) {
    //     let opt = {
    //       exhibitionId: "4e0e7148-4ad6-41f4-99a7-269e356d6391",
    //       companyName: this.formInline.companyName,
    //       unifiedCode: this.formInline.creditCode,
    //     };
    //     this.isMes = await this.getPCOrNHNEExist(opt);
    //     if (this.isMes) {
    //       this.$Message.warning("贵公司已提交过申请，如需修改信息请联系销售人员");
    //       //console.log(this.isMes, "this.isMes");
    //       return;
    //     } else {
    //       //console.log("该公司没有提交过申请");
    //     }
    //   }
    },

    getvalidate(prop, status, error) {
      if (status == false) {
        let opt = {
          prop: prop,
          status: status,
          error: error,
        };
        this.validateList.push(opt);
      }
    },
    deteleObject(obj) {
      var uniques = [];
      var uniquesNew = [];
      var stringify = {};
      for (var i = 0; i < obj.length; i++) {
        var keys = Object.keys(obj[i]);
        keys.sort(function (a, b) {
          return Number(a) - Number(b);
        });
        var str = "";
        for (var j = 0; j < keys.length; j++) {
          str += JSON.stringify(keys[j]);
          str += JSON.stringify(obj[i][keys[j]]);
        }
        if (!stringify.hasOwnProperty(str)) {
          uniques.push(obj[i]);
          stringify[str] = true;
        }
      }
      uniquesNew = uniques;
      return uniquesNew;
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, ) => {
        this.$refs[name].validate((valid) => {
          //console.log(valid, "valid");
          resolve(valid);
        });
      });
    },
    handleSuccess(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList.push({
          name: this.uploadName,
          url: res.list[0],
          status: "finished",
        });
      } else {
        this.uploadName = "";
      }
    },
    handleFormatError() {
      this.uploadName = "";
      this.$Notice.warning({
        title: "文件格式是不正确的/The File Format Is Invalid",
        desc: "请上传jpg或者png,pdf格式的图片/Please upload images in jpg or png or pdf",
      });
    },
    handleMaxSize() {
      this.uploadName = "";
      this.$Notice.warning({
        title: "文件大小超过限制/File size exceeds limit",
        desc: "请上传小于5M的图片或者pdf/Please upload images or pdf smaller than 5M",
      });
    },
    handleBeforeUpload(e) {
      this.uploadName = e.name;
      const limitNum = 1;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Notice.warning({
          title: `最多上传${limitNum}张图片/Upload up to ${limitNum} images`,
        });
      }
      return check;
    },
    handleRemoveByArr(file) {
      const fileList = this.uploadList;
      this.uploadList.splice(fileList.indexOf(file), 1);
    },
    async handleSubmit() {
      this.onBlurChang();
      if (this.isMes) {
        return;
      }

      let form = this.formInline;
      let valid = await this.validForm("formInline");
      let errTxt = "";
      if (!valid) {
        errTxt = this.validateList[0]
          ? this.validateList[0].error
          : "请完善表单/Please complete the form";
      }

      // 营业执照
      let imgBusinessLicense = "";
      if (this.isShowFormEl) {
        if (this.uploadList && this.uploadList.length) {
          imgBusinessLicense = this.uploadList[0];
        } else {
          errTxt = "请上传营业执照";
          valid = false;
        }
      }
      if (errTxt) {
        this.$Message.error(errTxt);
        this.validateList = [];
      }
      //console.log("form", this.formInline);
      let formValue = {
        companyName: form.companyName, // 公司名称
        companyNameShort: form.companyNameShort, // 公司简称
        companyNameEn: form.companyNameEn, // 公司英文名称
        unifiedCode: form.creditCode, // 统一社会信用代码
        address: form.address, // 详细地址
        country: form.addresss.country,
        province: form.addresss.province,
        city: form.addresss.city,

        postcode: form.postcode,
        productName: form.productName,

        // 展会联系人
        linkMan: form.linkMan,
        linkTitle: form.linkTitle,
        linkTelephone: form.linkTelephone,
        linkEmail: form.linkEmail,
        linkCode: form.linkCode, // 区号
        linkMob: form.linkMob, // 电话号码
        linkQQ: form.linkQQ,
        linkWeChat: form.linkWeChat,

        // 开票信息
        invoiceTitle: form.invoiceTitle,
        invoiceCode: form.invoiceCode,
        invoiceAddress: form.invoiceAddress,
        invoiceTelephone: form.invoiceTelephone,
        invoiceBank: form.invoiceBank,
        invoiceBankAccount: form.invoiceBankAccount,
        invoiceType: form.invoiceType,

        invoiceMalingCountry: form.invoiceMalingAdresss.country,
        invoiceMalingProvince: form.invoiceMalingAdresss.province,
        invoiceMalingCity: form.invoiceMalingAdresss.city,

        invoiceMalingAdress: form.invoiceMalingAdress,
        invoiceMalingCode: form.invoiceMalingCode,
        invoiceRecivePerson: form.invoiceRecivePerson,
        invoiceReciveTel: form.invoiceReciveTel,
        // imgBusinessLicense: JSON.stringify({ name: "", url: imgBusinessLicense }),
        imgBusinessLicense: JSON.stringify(imgBusinessLicense),
      };

      return new Promise((resolve, ) => {
        resolve({ valid: valid, form: formValue });
      });
    },
    validAddresss() {
      this.$refs["formInline"].validateField("addresss", () => {
        //console.log("addresss", valid);
      });
    },
    MalingAdresssAddresss() {
      this.$refs["formInline"].validateField("invoiceMalingAdresss", () => {
        //console.log("addresss", valid);
      });
    },
  },
};
</script>

<style scoped lang="scss">
.basic {
  h3 {
    font-weight: 500;
  }
  /deep/ {
    .ivu-checkbox-checked .ivu-checkbox-inner {
      border-color: #00a0e9;
      background-color: #00a0e9;
    }

    .ivu-upload-select {
      display: flex;
    }

    .ivu-radio-checked .ivu-radio-inner {
      border-color: #00a0e9 !important;
    }

    .ivu-radio-inner:after {
      background-color: #00a0e9;
    }

    .ivu-switch-checked {
      border-color: #00a0e9;
      background-color: #00a0e9;
    }
  }

  &-header {
    width: 100%;
    height: 64px;
    background-color: #00a0e9;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;

    h2 {
      line-height: 64px;
      font-size: 20px;
      font-weight: 500;
    }

    span {
      width: 30px;
      height: 1px;
      background-color: #fff;
      margin: 0 15px;
    }
  }

  &-name {
    padding: 10px 0 10px 30px;
    background-color: #fff;
  }

  &-address {
    padding: 10px 0 20px 30px;
    background-color: #fff;
  }

  &-phone {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-license {
    padding: 30px 0 10px 30px;
    background-color: #ededed;
  }

  .upload-btn {
    // width: 180px;
    padding: 0 5px;
    height: 32px;
    text-align: center;
    cursor: pointer;
    background-color: #f5f5f5;
    border: 1px dotted #bfbfbf;
  }

  .license-img {
    display: flex;
    flex-wrap: wrap;

    &-list {
      line-height: 32px;
      padding: 0 10px;
      background-color: #f5f5f5;
      display: flex;
      align-items: center;
      margin-right: 10px;
      margin-bottom: 10px;

      .txt1 {
        width: 200px;
        display: inline-block;
        height: 32px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #515a6e !important;
      }

      span {
        color: #ff0011;
        cursor: pointer;
      }

      .line {
        width: 1px;
        height: 24px;
        background-color: #e6e6e6;
        margin: 0 6px;
      }
    }
  }

  &-export {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-scale {
    padding: 30px 0 10px 30px;
    background-color: #ededed;
  }

  &-tech {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-link {
    padding: 0 30px;
    background-color: #ededed;

    .ivu-form-item {
      margin-bottom: 0;
      line-height: 48px;

      /deep/ .ivu-form-item-label {
        font-size: 18px;
        padding: 0;
      }
    }
  }

  &-links {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-leader {
    padding: 0 30px;
    background-color: #ededed;
    position: relative;

    .ivu-form-item {
      margin-bottom: 0;
      line-height: 48px;

      /deep/ .ivu-form-item-label {
        font-size: 18px;
        padding: 0;
      }
    }

    .above {
      position: absolute;
      left: 240px;
      top: 10px;
    }
  }

  &-leaders {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-invoiceType {
    padding: 0 30px;
    background-color: #ededed;
    line-height: 48px;
    display: flex;
    justify-content: space-between;

    .ivu-checkbox-wrapper {
      margin: 0;
    }

    span {
      color: #ff0000;
      margin-left: 5px;
    }
  }

  &-invoices {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }
}
</style>
